import { Link } from 'react-router-dom';
import { RevealOnScroll } from './motion/RevealOnScroll';

const footerLinks = [
  { to: '/about', label: 'About us' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/privacy', label: 'Data privacy' },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 py-8 text-zinc-500">
      <RevealOnScroll
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left"
        y={12}
      >
        <p>&copy; {year} Chase it for me. All rights reserved.</p>
        <nav className="flex items-center gap-6">
          {footerLinks.map((link) => (
            <Link key={link.to} to={link.to} className="text-sm hover:text-zinc-300 transition-colors">
              {link.label}
            </Link>
          ))}
        </nav>
      </RevealOnScroll>
    </footer>
  );
}
